'use client';

/**
 * PR1 stub. In PR2 this will subscribe to /api/hub/priority-stack
 * and return a real count of decisions waiting for the owner.
 */
export function useHunterPriority(): { count: number; pending: boolean } {
  return { count: 0, pending: false };
}
